import React from "react";
import styles from "./bodywon.module.css";
import { ensureCatalogToken } from "../admin/jscontrol/apiClient";
import { fetchActiveHeroBanners } from "../utils/bannerStorefront";

const BodywonHero = ({ catalogReady }) => {
  const [slides, setSlides] = React.useState([]);
  const [index, setIndex] = React.useState(0);

  React.useEffect(() => {
    if (!catalogReady) return undefined;
    let cancelled = false;

    const loadBanners = async () => {
      ensureCatalogToken();
      try {
        const active = await fetchActiveHeroBanners();
        if (!cancelled) {
          setSlides(active);
          setIndex(0);
        }
      } catch {
        if (!cancelled) setSlides([]);
      }
    };

    loadBanners();
    return () => {
      cancelled = true;
    };
  }, [catalogReady]);

  const totalSlides = slides.length;

  React.useEffect(() => {
    if (totalSlides <= 1) return undefined;
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % totalSlides);
    }, 5000);
    return () => clearInterval(timer);
  }, [totalSlides]);

  React.useEffect(() => {
    if (index >= totalSlides) setIndex(0);
  }, [index, totalSlides]);

  if (totalSlides === 0) return null;

  const current = slides[index] || slides[0];

  const img = (
    <img
      className="imgBanner"
      src={current?.imageSrc}
      alt={current?.alt}
      style={{ width: "100%", display: "block", transition: "opacity 0.5s ease" }}
    />
  );

  return (
    <section className={styles.heroSection}>
      <div style={{ position: "relative", overflow: "hidden" }}>
        {current?.redirectUrl ? (
          <a href={current.redirectUrl} style={{ display: "block" }}>
            {img}
          </a>
        ) : (
          img
        )}
        {totalSlides > 1 && (
          <div
            style={{
              position: "absolute",
              bottom: "16px",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              gap: "8px",
            }}
          >
            {slides.map((slide, i) => (
              <button
                key={slide.id ?? i}
                type="button"
                onClick={() => setIndex(i)}
                style={{
                  width: i === index ? "24px" : "10px",
                  height: "10px",
                  borderRadius: "5px",
                  border: "none",
                  background: i === index ? "#fff" : "rgba(255,255,255,0.5)",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  padding: 0,
                }}
                aria-label={`Go to slide ${i + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default BodywonHero;
